// This requires and globally exposes the dependencies needed by code that is
// still in the Rails Asset Pipeline (and therefore can't yet directly import
// modules from Webpack)

/* eslint-disable */

if (module?.hot) {
  module.hot.accept();
}

import Mustache from 'mustache';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import underscore from 'underscore';

// Misc libs
window.pluralize = require('pluralize');

require('accounting');
require('jquery');
require('jquery-ui/ui/widgets/autocomplete');
require('dotdotdot');
require('blueimp-file-upload');
require('blueimp-file-upload/js/jquery.iframe-transport');
require('expanding-textareas/dist/expanding.jquery');

// Backbone and extensions

// Store our version of underscore before anything else can override it
const COVIDENCE_UNDERSCORE = underscore;

// Expose underscore globally for legacy code and libraries that expect it
global._ = underscore;

// Protected namespace - this reference will never be overridden by PDF viewer or extensions
window.Covidence = window.Covidence || {};
window.Covidence._ = COVIDENCE_UNDERSCORE;

// Expose mustache on window for old templates
// This replicates how jquery mustache used to work
$.mustache = (template, view = {}, partials) =>
  Mustache.render(template, view, partials);

require('backbone-pageable');
require('backbone-relational');
Backbone.Relational.store.addModelScope(window);
require('backbone.stickit');
// Stickit's built-in radio handler interpolates the model value into an attribute
// selector, which throws for values containing quotes, brackets or backslashes.
Backbone.Stickit.addHandler([
  {
    selector: 'input[type="radio"]',
    update: function ($el, val) {
      const selectedValue = String(val);
      $el
        .filter(function () {
          return this.value === selectedValue;
        })
        .prop('checked', true);
    },
  },
]);

// Legacy mobile screening app relies on localStorage which is NOT ATOMIC.
// Multiple tabs cause data races. This is used to wrap localStorage access
// critical section in an IndexedDB transaction as a hack to create a mutex.
global.Mutex = require('idb-mutex').default;

/* eslint-enable */
